import React, { Component } from 'react';
import { connect } from 'react-redux';

class FilterItems extends Component {

  render() {
    return (
      <section>
        {
          this.props.cards.map((data) => {
            const selected = (data.selected) ? ' selected' : '';
            return (
              <div key={data.id} className={"filter-card" + selected}>
                <p>{data.text}</p>
              </div>
            )
          })
        }
      </section>
    );
  }
}

const mapState = (state) => {

  return {
    cards: state.influenceData.cards,
  }
};

export default connect(mapState)(FilterItems);



// WEBPACK FOOTER //
// ./src/components/Influence/Filter/FilterItems/FilterItems.js